// Components==============
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import './ProjectShareCode.module.scss';
// =========================
type Status = 'inactive' | 'copied';

const variantsLeft = {
  inactive: {
    color: '#0827e9',
  },
  copied: {
    color: '#2addd0',
  },
};

const variantsRight = {
  inactive: {
    background: '#0827e9',
  },
  copied: {
    background: '#2addd0',
  },
};

export default function ProjectShareCode() {
  const translate = useTranslate();
  const [status, setStatus] = useState<Status>('inactive');

  const { project } = useContext(ProjectDetailsContext);

  function copiedClick() {
    navigator.clipboard.writeText(
      `https://learntogroow.com/extern-uitnodiging/${project?.share_code}`
    );
    setStatus('copied');
    setTimeout(function () {
      setStatus('inactive');
    }, 2000);
  }

  return (
    <div styleName="sharecode-button">
      <Tooltip
        fullWidth
        position="bottom"
        content={<p>{translate('portfolio.sharecode-tooltip-portfolio')}</p>}
      >
        <motion.div
          variants={variantsLeft}
          animate={status}
          initial="inactive"
          styleName="left"
        >
          <p>
            https://learntogroow.com/extern-uitnodiging/{project?.share_code}
          </p>
        </motion.div>
      </Tooltip>
      <motion.div
        whileHover={status !== 'copied' ? { background: '#2c48f8' } : undefined}
        variants={variantsRight}
        animate={status}
        initial="inactive"
        styleName="right"
        onClick={() => {
          copiedClick();
        }}
      >
        <FontAwesomeIcon icon={status === 'inactive' ? faCopy : faCheck} />
      </motion.div>
    </div>
  );
}
